import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { matches } from "@/lib/text";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Search, Phone, X, UserPlus, Check } from "lucide-react";

export function CustomerPicker({ value, onSelect, onNew }) {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/customers").then((r) => setList(r.data)).catch(() => setList([])); }, []);

  if (value) {
    return (
      <div className="flex items-center gap-3 p-3 rounded-lg border border-emerald-300 bg-emerald-50 dark:bg-emerald-900/20 dark:border-emerald-800" data-testid="selected-customer">
        <div className="w-9 h-9 rounded-full bg-emerald-600 text-white flex items-center justify-center font-bold shrink-0">{value.name[0]?.toUpperCase()}</div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-slate-900 dark:text-white truncate" data-testid="selected-customer-name">{value.name}</p>
          <p className="text-xs text-slate-600 dark:text-slate-300 flex items-center gap-1"><Phone className="w-3 h-3" /> {value.phone}</p>
        </div>
        <Button variant="ghost" size="sm" onClick={() => onSelect(null)} data-testid="change-customer-btn"><X className="w-4 h-4 mr-1" /> Trocar</Button>
      </div>
    );
  }

  const results = q.trim() ? list.filter((c) => matches(q, c.name, c.phone)).slice(0, 8) : [];
  return (
    <div className="space-y-2">
      <Label>Cliente</Label>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input data-testid="customer-picker-input" className="pl-9" placeholder="Buscar cliente por nome ou telefone..." value={q} onChange={(e) => setQ(e.target.value)} autoComplete="off" />
      </div>
      {q.trim() && (
        <ul className="rounded-lg border border-slate-200 dark:border-slate-800 divide-y divide-slate-100 dark:divide-slate-800 max-h-56 overflow-y-auto" data-testid="customer-picker-results">
          {results.map((c) => (
            <li key={c.phone}>
              <button type="button" onClick={() => { onSelect(c); setQ(""); }} data-testid={`customer-option-${c.phone}`}
                className="w-full flex items-center gap-3 px-3 py-2 text-left hover:bg-emerald-50 dark:hover:bg-slate-800 transition-colors">
                <Check className="w-4 h-4 text-emerald-500 opacity-0" />
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium text-slate-900 dark:text-white truncate">{c.name}</span>
                  <span className="block text-xs text-slate-500 font-mono">{c.phone}</span>
                </span>
              </button>
            </li>
          ))}
          {results.length === 0 && <li className="px-3 py-2 text-sm text-slate-500" data-testid="customer-picker-empty">Nenhum cliente encontrado.</li>}
        </ul>
      )}
      <Button type="button" variant="outline" size="sm" onClick={onNew} data-testid="new-customer-btn"><UserPlus className="w-4 h-4 mr-1" /> Cadastrar cliente novo</Button>
    </div>
  );
}
